import React, {Component, useState, useEffect} from 'react';
import {connect} from 'react-redux';

const TestContainer2 = (props) => {

  const [isLoaded, setIsLoaded] = useState(false)
  const [state, setState] = useState({})

  useEffect(() => {

  })

  return (
    <div>
      Hi, Dana
    </div>
  )
}

const enhance = connect(
  state => ({
    ...state
  }),
  {}
);

export default enhance(TestContainer2);
